export interface RealocacaoItem {
  id_item: number;
  ordemProducao: string;
  programacao: string;
  produto: string;
  faccaoProducao: string;
  faccaoPedidoTriangulado: string;
  reservaFinal: number;
  quantidadeRealocar: number;
  pedidoMp?: string;
  material?: string;
  descMaterial?: string;
  corMaterial?: string;
  descCorMaterial?: string;
  descRedeLojas?: string;
  time?: string;
  compradora?: string;
  responsavelPcp?: string;
  fornecedorMp?: string;
  dataEmissaoPedido?: Date | string | null;
  dataFaturamento?: Date | string | null;
  faturado?: string;
}

export interface RealocacaoPedidosMpItens {
  descRedeLojas: string;
  time: string;
  compradora: string;
  responsavelPcp: string | null;
  material: string;
  descMaterial: string;
  corMaterial: string;
  descCorMaterial: string;
  fornecedorMp: string;
  pedidoMp: string;
  dataEmissaoPedido: Date | string | null;
  dataFaturamento: Date | string | null;
  pedidoFaturado: string;
  itens: RealocacaoItem[];
}



export enum StatusFaturamento {
  FATURADO = 'PEDIDO FATURADO',
  NAO_FATURADO = 'PEDIDO NÃO FATURADO'
}

export type TipoResponsavel = 'COMPRADORA' | 'PCP';

export function determinarResponsavel(dataFaturamento: Date | string | null): TipoResponsavel {
  return dataFaturamento === null ? 'COMPRADORA' : 'PCP';
}

export function determinarStatusFaturamento(dataFaturamento: Date | string | null): StatusFaturamento {
  return dataFaturamento === null ? StatusFaturamento.NAO_FATURADO : StatusFaturamento.FATURADO;
}

export function formatarData(data: Date | string | null): string {
  if (!data) return '—';
  const dateObj = typeof data === 'string' ? new Date(data) : data;
  if (isNaN(dateObj.getTime())) return '—';
  return dateObj.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
}

export function formatarNumero(valor: number | undefined | null): string {
  if (valor === undefined || valor === null) return '0,00';
  return valor.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
